<div class="c-proxy-head">
	<div class="info-block">
		<div class="head-title">
			{{yield 'title'}}
		</div>

		{{yield 'img'}}

		<div class="head-descr">
			{{yield 'descr'}}
		</div>

		<div class="head-links">
			<a href="{{link}}" target="_blank" rel="noopener noreferrer">{{link}}</a>
			<a href="{{docsLink}}" target="_blank" rel="noopener noreferrer">Documentation</a>
			<a href="{{jsDelivrLink}}">jsDelivr Project Page</a>
		</div>
	</div>

	{{yield 'img'}}
</div>
